import { getSupabaseBrowserClient } from "@/lib/supabase/client";

async function getAuthenticatedUserId() {
  const supabase = getSupabaseBrowserClient();
  const {
    data: { user },
    error,
  } = await supabase.auth.getUser();

  if (error) {
    throw error;
  }

  if (!user) {
    throw new Error("A bevezetés frissítéséhez be kell jelentkeznie.");
  }

  return { supabase, userId: user.id };
}

export async function markIntroductionServicesViewed(): Promise<void> {
  const { supabase, userId } = await getAuthenticatedUserId();
  const { error } = await supabase
    .from("profiles")
    .update({ introduction_services_viewed: true })
    .eq("id", userId);

  if (error) {
    throw error;
  }
}

export async function skipIntroductionChecklist(): Promise<void> {
  const { supabase, userId } = await getAuthenticatedUserId();
  const { error } = await supabase
    .from("profiles")
    .update({
      introduction_services_viewed: true,
      introduction_settings_completed: true,
      introduction_skipped: true,
    })
    .eq("id", userId);

  if (error) {
    throw error;
  }
}
